import React, { Component } from 'react';
import PropTypes from 'prop-types';

class CustomRowRenderer extends Component {
  static propTypes = {
    className: PropTypes.string,
    idx: PropTypes.number,
    activeIdx: PropTypes.number,
    highlightActiveRow: PropTypes.bool,
    renderBaseRow: PropTypes.func
  };

  static defaultProps = {
    className: '',
    highlightActiveRow: false,
    idx: -1,
    activeIdx: -1,
    renderBaseRow: () => null
  }

  render() {
    const {
      renderBaseRow,
      highlightActiveRow,
      activeIdx,
      idx,
      ...rest
    } = this.props;

    return highlightActiveRow ? (
      <div>
        {
          renderBaseRow({
            ...rest,
            activeIdx,
            idx,
            isSelected: activeIdx === idx,
          })
        }
      </div>
    ) : (
      <div>
        {renderBaseRow(this.props)}
      </div>
    );
  }
}

export default CustomRowRenderer;
